export default "__VITE_ASSET__nWYPiP4i__"